module.exports = __webpack_public_path__ + "img/cloud-solid.b20a84e5.svg";